import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";

export default function RichiediCompagniaDialog({ open, onOpenChange }) {
  const [nome, setNome] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setNome(""); setNote(""); } }, [open]);
  const send = async () => {
    if (!nome.trim()) { toast.error("Inserisci il nome della compagnia"); return; }
    setBusy(true);
    try {
      await api.post("/studio/compagnie/richieste", { nome: nome.trim(), note: note.trim() });
      toast.success("Richiesta inviata all'amministratore");
      onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!busy) onOpenChange(o); }}>
      <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-md" data-testid="richiedi-compagnia-dialog">
        <DialogHeader><DialogTitle className="font-head">Richiedi nuova compagnia</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-400">Le compagnie assicurative sono gestite centralmente. Invia la richiesta e verrà aggiunta per tutti gli studi.</p>
        <div className="space-y-3">
          <div>
            <Label className="text-slate-300">Nome compagnia</Label>
            <Input value={nome} onChange={(e) => setNome(e.target.value)} data-testid="richiedi-compagnia-nome" className="mt-1.5 bg-slate-900/60 border-slate-700" />
          </div>
          <div>
            <Label className="text-slate-300">Note</Label>
            <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={4} placeholder="Es. indirizzo, PEC, codice ANIA…" data-testid="richiedi-compagnia-note" className="mt-1.5 bg-slate-900/60 border-slate-700" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={send} disabled={busy || !nome.trim()} data-testid="richiedi-compagnia-invia" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Send className="h-4 w-4 mr-1" /> Invia richiesta</>}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
